import StaffForm from "./StaffForm"


const StaffAdd = () => {
  return (
    <div className='page-body'>
      <StaffForm />
    </div>
  )
}

export default StaffAdd